/* eslint-disable */
import {UntypedFormControl, NG_VALIDATORS, Validator, ValidatorFn} from '@angular/forms';

import {Directive, EventEmitter, Input, Output} from '@angular/core';


@Directive({
  selector: '[pricevalidator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PriceValidator,
      multi: true
    }
  ]
})

export class PriceValidator implements Validator {

  @Input('decimals') decimals = 2;
  @Input('max') max = 99999999;
  @Input('min') min = 0;
  @Input('allownull') allownull: boolean;
  @Output('validPrice') priceEvent: EventEmitter<any> = new EventEmitter();

  validator: ValidatorFn;


  constructor() {
    this.validator = this.priceValidator();
  }

  validate(c: UntypedFormControl) {

    const resp = this.validator(c);

    if (resp) {

      this.priceEvent.emit({'invalid': true});

    }

    return resp;

  }


  priceValidator(): ValidatorFn {

    return (c: UntypedFormControl) => {

      let modelValue = c.value || '';

      modelValue = ('' + modelValue).trim();

      if (modelValue === '' && this.allownull) {

        return null;
      }


      if (isNaN(modelValue) || modelValue === Infinity || modelValue === -Infinity) {

        return {
          pricevalidator: {
            format: true
          }
        };


      }

      let miRegExp = /^[0-9]+(\.[0-9]*)?/gi; // Sin + - al comienzo

      let re = new RegExp(miRegExp);

      const str = ('' + (c.value)).trim();

      if (!str.match(re)) {

        return {
          pricevalidator: {
            format: true
          }
        };
      }

      miRegExp = /[eE]/gi;
      re = new RegExp(miRegExp);

      if (str.match(re)) {

        return {
          pricevalidator: {
            format: true
          }
        };
      }

      const pos = str.indexOf('.');

      let decimalPart = null;
      let integerPart = null;

      if (pos >= 0) {

        integerPart = str.substr(0, pos);
        decimalPart = str.substr(pos + 1);

      } else {

        integerPart = str;
      }

      if (integerPart === null) {

        return {
          pricevalidator: {
            integers: true
          }
        };

      }

      if (decimalPart === '') {

        return {
          pricevalidator: {
            decimalsformat: true,
            decimalsvalue: this.decimals
          }
        };
      }


      if (decimalPart && decimalPart.length > this.decimals) {

        return {
          pricevalidator: {
            decimals: true,
            decimalsvalue: this.decimals
          }
        };
      }

      const p = parseFloat(modelValue);

      if (this.max !== undefined && p > this.max) {

        return {
          pricevalidator: {
            max: true,
            maxvalue: this.max
          }
        };
      }

      if (this.min !== undefined && p < this.min) {

        return {
          pricevalidator: {
            min: true,
            minvalue: this.min
          }
        };
      }

      this.priceEvent.emit({'float': p, 'string': modelValue});


      return null; // IS VALID

    };

  }
}

